<template>
  <div
    v-click-outside="closeList"
    class="dropdown-component generic-border--text-btn generic-border--clickable"
    :class="dropdownClasses"
    @click.stop="openDropdown"
  >

    <TransitionExpand>
      <div v-if="!isOpened">
        <div class="dropdown-component__closed-text">
          {{ closedText }}
        </div>
      </div>
    </TransitionExpand>

    <TransitionExpand>
      <div v-if="isOpened" class="dropdown-component__content">
        <slot />
      </div>
    </TransitionExpand>
    <div @click.stop="toggleDropdown">
      <Icon class="dropdown-component__expand-arrow">
        {{ arrowDownLine }}
      </Icon>
    </div>
  </div>
</template>

<script>
/**
 * Dropdown component for listing options.
 *
 * @vue-prop {String} closedText - Text to display when the dropdown is closed
 * @vue-prop {Boolean} [disabled] - Disable dropdown
 */

// Import components
import Icon from '@/components/icon.vue';
import TransitionExpand from '@/components/transition-expand.vue';
// Utils & assets
import { arrowDownLine } from '@/assets/icons/';

export default {

  name: 'Dropdown',

  components: {
    Icon,
    TransitionExpand,
  },

  props: {
    closedText: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    small: Boolean,
  },

  data() {
    return {
      arrowDownLine,
      isOpened: false,
    };
  },

  computed: {
    dropdownClasses() {
      const { isOpened, small } = this;
      return {
        'dropdown-component--opened': isOpened,
        'dropdown-component--small': small,
      };
    },
  },

  methods: {
    closeList() {
      this.isOpened = false;
    },
    /** Open the dropdown content */
    openDropdown() {
      if (!this.disabled) {
        this.isOpened = true;
      }
    },
    toggleDropdown() {
      if (!this.disabled) {
        this.isOpened = !this.isOpened;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

// Override generic-border rule for scroll
.generic-border--text-btn > div.dropdown-component__content {
  overflow: auto;
}

.dropdown-component {
  position: relative;
  min-width: 200px;
  max-width: 300px;
  background-color: $color-body-background;
  position: relative;
  min-height: 3rem;
  z-index: 1;
  transition: background-color 0.2s;

  &.generic-border--text-btn {
    border-radius: $high-border-radius;
    padding: 0;
  }

  &--opened {

    svg.icon {
      transform: rotate(180deg);
      z-index: 1;
    }
  }

  &--small.dropdown-component {
    height: 2.1rem;
    min-height: 0;

    .dropdown-component__closed-text {
      padding: 0.4rem 1.25rem;
    }

    svg.icon {
      padding: 0.5rem 0.4rem;
      margin-right: 0.625rem;
    }

    &.dropdown-component--opened {

      svg.icon {
        top: 0.2rem;
      }
    }
  }

  &__content {
    position: absolute;
    background-color: $color-body-background;
    top: -1px;
    left: -1px;
    width: calc(100% + 2px);
    z-index: 1;
    border: 1px solid $color-gray-border;
    border-radius: $high-border-radius;
    max-height: 300px;
    overflow-y: auto;
  }

  &__closed-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0.9rem;
    margin-right: 1.8rem;
  }

  svg.icon {
    position: absolute;
    top: 0.1rem;
    right: 0.3rem;
    padding: 0.9rem;
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 2rem;
    transition: background 0.2s;

    &:hover {
      background: rgba(0, 0, 0, 0.07)
    }
  }

  &__content {
    background: #fff;
  }
}

@media (max-width: $smartphone-portrait) {
  .gw-completed {

    &__participant {
      display: none;
    }

    .gw-sr-checklists {
      width: 100%;
    }

    .panel-splitter {
      overflow: auto;

      &--column .panel-splitter__panel:not(:first-child) {
        border-top-width: 5px;
      }
    }

    .gw-completed-steps {
      overflow-y: visible;
    }
  }
}

@media (max-width: $smartphone-portrait) {
  .dropdown-component {
    &--small {

      .dropdown-component__closed-text {
        padding: 0.438rem 1.25rem;
      }

      svg.icon {
        top: 0.25rem;
      }
    }
  }
}
</style>
